import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit, ViewEncapsulation, inject } from '@angular/core';

import { ClockService, CommonMessages, DateTimeService, HtmlNode, LocalStoreKey, LocalStoreService, SlotName } from '@frontend/vanilla/core';
import { firstValueFrom } from 'rxjs';

import { ClockConfig } from './clock.client-config';

@Component({
    imports: [CommonModule],
    selector: 'vn-clock',
    templateUrl: './clock.html',
    styleUrls: ['../../../../../themepark/themes/whitelabel/components/clock/styles.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ClockComponent implements OnInit, OnDestroy {
    @Input() format = 'mediumTime';
    @Input() slotName: SlotName;

    readonly commonMessages = inject(CommonMessages);
    private readonly clockConfig = inject(ClockConfig);
    private readonly clockService = inject(ClockService);
    private readonly htmlNode = inject(HtmlNode);
    private readonly localStoreService = inject(LocalStoreService);
    private readonly dateTimeService = inject(DateTimeService);

    private htmlNodeClassName: string;

    readonly time = this.clockService.tick<Date>(() =>
        this.clockConfig.isConfigReady && this.clockConfig.useWithTimeZone ? this.dateTimeService.convertLocalToUserTimezone(new Date()) : new Date(),
    );

    async ngOnInit() {
        await firstValueFrom(this.clockConfig.whenReady);

        if (this.clockConfig.dateTimeFormat) {
            this.format = this.clockConfig.dateTimeFormat;
        }

        this.htmlNodeClassName = `${this.slotName?.toLowerCase() ?? 'custom'}-clock-shown`;
        this.htmlNode.setCssClass(this.htmlNodeClassName, true);

        this.storeSownCount();
    }

    ngOnDestroy() {
        this.htmlNode.setCssClass(this.htmlNodeClassName, false);
    }

    private storeSownCount() {
        let clockShowCounter = this.localStoreService.get<number>(LocalStoreKey.ClockShowTimes);

        if (clockShowCounter) {
            if (clockShowCounter > 2) {
                this.localStoreService.set<number>(LocalStoreKey.ClockShowTimes, 0);
            } else {
                this.localStoreService.set<number>(LocalStoreKey.ClockShowTimes, clockShowCounter++);
            }
        } else {
            this.localStoreService.set<number>(LocalStoreKey.ClockShowTimes, 1);
        }
    }
}
